import React from 'react';

import cx from 'classnames';

import { Direction, Mode, Popper } from '~shared/components/Popper/Popper';

// type test
export interface Link extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string;
  label: string;
  color?: string;
  onClick?: () => void;
}
interface Props {
  links: Link[];
  children: React.ReactNode;
  direction?: Direction;
  mode?: Mode;
  isDisabled?: boolean;
}

/**
 *  Simple Component that renders a link menu from an array of link objects
 *  ** related to the ActionMenu component
 *  ** is its own component since its far simpler and doesn't require action logic
 */
export const LinkMenu = ({
  children,
  links,
  direction,
  mode,
  isDisabled,
}: Props) => {
  if (!links) return <>{children}</>;
  return (
    <Popper
      keyboardNavigable
      theme={'dark'}
      isDisabled={isDisabled}
      content={(close) => (
        <div className={'w-70 shadow-modal rounded-3 bg-white p-5'}>
          {links.map(({ href, label, className, color }) => {
            // here is where you apply the disabled items
            return (
              <a
                tabIndex={0}
                data-key={label}
                href={href}
                key={label}
                className={cx(
                  'w-full p-3 text-sm rounded-3 block no-underline',
                  className && className,
                  'hocus:bg-grey-50'
                )}
                style={{
                  cursor: 'pointer',
                  opacity: '1',
                  color: color ? color : 'inherit',
                }}
                onClick={() => close()}
              >
                {label}
              </a>
            );
          })}
        </div>
      )}
      direction={direction || 'bottom-end'}
      mode={mode || 'click'}
    >
      {children}
    </Popper>
  );
};
